import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=c7936f64&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"
import style0 from "styles/pages/health-file/index.less?vue&type=style&index=0&lang=less&"
import style1 from "styles/components/header.less?vue&type=style&index=1&lang=less&"
import style2 from "./Default.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports